export default __webpack_public_path__ + "static/media/inversionista.9f2900d7.png";